export default __webpack_public_path__ + "static/media/2.08f99345.png";